(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["blun-bundle-row"] && !Shopify.designMode) return;
  try {
    class BlunBundleRow extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.blun-brow__btn');
      this.label = this.querySelector('.blun-brow__btn-label');
      if (!this.button) return;
      this.defaultLabel = this.label.textContent;
      this.button.addEventListener('click', () => this.add());

      this.prices = new Map(
        (this.dataset.variantPrices || '')
          .split(',')
          .filter(Boolean)
          .map((pair) => pair.split(':').map(Number))
      );

      // The picker markup varies between themes and Horizon re-renders it, so
      // listen at document level rather than binding to specific inputs.
      document.addEventListener('change', () => this.refresh());
      document.addEventListener('variant:update', () => this.refresh());
      this.refresh();
    }

    #money(cents) {
      const n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `Rs.${n}`;
    }

    refresh() {
      if (this.dataset.fixedMain === 'true') return;
      const id = this.#currentMainVariant();
      const mainPrice = this.prices.get(id);
      if (mainPrice === undefined) return;

      const partner = Number(this.dataset.partnerPrice) || 0;
      const total = mainPrice + partner;
      const base = this.dataset.discountBase === 'main' ? mainPrice : partner;

      let saving =
        this.dataset.discountType === 'percent'
          ? Math.round((base * Number(this.dataset.discountValue)) / 100)
          : Number(this.dataset.discountValue) * 100;
      if (saving >= total) saving = 0;

      const was = this.querySelector('.blun-brow__was');
      const now = this.querySelector('.blun-brow__now');
      const tag = this.querySelector('.blun-brow__tag');
      if (now) now.textContent = this.#money(total - saving);
      if (was) {
        was.textContent = this.#money(total);
        was.hidden = saving === 0;
      }
      if (tag) {
        tag.textContent = `Save ${this.#money(saving)}`;
        tag.hidden = saving === 0;
      }
    }

    // The main product's variant is read from the live form, not from the
    // server-rendered id. On a product with sizes the shopper may have changed
    // the selection since the page was built, and adding the default weight
    // instead of the one they picked is the worst kind of silent bug.
    #currentMainVariant() {
      // Pinned to one variant: the picker on the page must not change it.
      if (this.dataset.fixedMain === 'true') return Number(this.dataset.variantA);
      const input = document.querySelector(
        'product-form-component input[name="id"], form[action*="/cart/add"] [name="id"]'
      );
      const live = input && Number(input.value);
      return live || Number(this.dataset.variantA);
    }

    async add() {
      const a = this.#currentMainVariant();
      const b = Number(this.dataset.variantB);
      if (!a || !b) return;

      this.button.disabled = true;
      this.label.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: a, quantity: 1 },
              { id: b, quantity: 1 },
            ],
          }),
        });
        if (!res.ok) throw new Error(await res.text());
        window.location.href = '/cart';
      } catch (e) {
        console.error('Bundle row add failed', e);
        this.button.disabled = false;
        this.label.textContent = 'Try again';
        setTimeout(() => {
          this.label.textContent = this.defaultLabel;
        }, 2200);
      }
    }
  }

  if (!customElements.get('blun-bundle-row')) {
    customElements.define('blun-bundle-row', BlunBundleRow);
  }
  } catch(e) { console.error(e); }
})();

})();
